angular.module('callX').controller('ApplicationPageEditCtrl', ['$scope', '$modalInstance', '$state', 'UserService', 'toaster', '$rootScope', 'object', '$timeout', '$stateParams',function($scope, $modalInstance, $state, UserService, toaster,$rootScope, object, $timeout, $stateParams) {
    
    $scope.insuredTypes = ['Final Expense', 'Term', 'Universal Life'];
    $scope.statusOptions = ['Approved','Declined', 'Underwriting'];
    $scope.companies = [];
    $scope.products = [];
    $scope.filteredAgentNames = [];
    angular.forEach($rootScope.agentNames, function(agent) {
        if (agent.id != $stateParams.userId) {
            $scope.filteredAgentNames.push(agent);
        }
    });
    $scope.isCompanyDropdownLoading = true;

    $scope.editApplication = JSON.parse(JSON.stringify(object.application));
     // Format effective_date to dd/MM/yyyy

    $scope.editApplication.effective_date = formatDate($scope.editApplication.effective_date);
    $scope.editApplication.submitted_date = formatDate($scope.editApplication.submitted_date);
  
    $scope.updateAnnualPayment = function() {
            $scope.editApplication.annual_payment = $scope.editApplication.monthly_payment ? $scope.editApplication.monthly_payment * 12 : '';
            $scope.editApplication.annual_payment = $scope.editApplication.annual_payment ? $scope.editApplication.annual_payment.toFixed(2) : '';
    };

    $scope.updateMonthlyPayment = function() {
            $scope.editApplication.monthly_payment = $scope.editApplication.annual_payment ? $scope.editApplication.annual_payment / 12 : '';
            $scope.editApplication.monthly_payment = $scope.editApplication.monthly_payment ? $scope.editApplication.monthly_payment.toFixed(2) : '';
    };

    $scope.sortByName = function(data) {
        return data.sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
    };

    $scope.getCarrierDetails = function(){
        $scope.isCompanyDropdownLoading = true;
    	var callbacks = {
            success: function (data) {
                $scope.companies = $scope.sortByName(data);
                $scope.isCompanyDropdownLoading = false;
                var selectedCompany = $scope.companies.find(function(company) {
                    return company.id === $scope.editApplication.carrier_id;
                });
                $scope.editApplication.carrierObject = selectedCompany
             },
            failure: function (data) {
                $scope.isCompanyDropdownLoading = false;
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }

        };
        UserService.getCarrierDetails(callbacks);
    };

    $scope.getProductsBasedOnCarrier = function(carrierId){
        $scope.products = []
    	var callbacks = {
            success: function (data) {
                $scope.products = data;
                if($scope.editApplication.product_id) {
                    var selectedProduct =  $scope.products.find(function(product) {
                        return product.id == $scope.editApplication.product_id;
                    });
                    $scope.editApplication.productObject = JSON.stringify(selectedProduct)
                    delete $scope.editApplication.product_id;
                }
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }

        };
        UserService.getProductsBasedOnCarrier(carrierId, callbacks);
    };
    $scope.getCarrierDetails()

    function formatDate(date) {
        if (!date) return '';
        const dateObject = new Date(date.split(' ')[0] + 'T00:00:00'); // Convert to Date object
        const day = ('0' + dateObject.getDate()).slice(-2);
        const month = ('0' + (dateObject.getMonth() + 1)).slice(-2);
        const year = dateObject.getFullYear();
        return month + '/' + day + '/' + year;
    }

    $scope.$watch('editApplication.carrierObject', function(newValue) {
        if (newValue) {
            var selectedCompany = $scope.companies.find(function(company) {
                return company.id === newValue.id;
            });
            // $scope.editApplication.carrier_name = selectedCompany.name;
            $scope.products = []
            $scope.editApplication.productObject = null
             $scope.editApplication.carrierObject = selectedCompany;
             $scope.getProductsBasedOnCarrier($scope.editApplication.carrierObject.id)
        }
    });

    $scope.productChange = function(val) {
        if(val) {
            $scope.editApplication.insurance_type = JSON.parse(val).product_type
        }
    };

    $scope.$watch('editApplication.split_agent_id', function(newValue) {
        if (newValue) {
            var selectedAgent = $scope.agentNames.find(function(agent) {
                return agent.id === newValue;
            });
            // $scope.editApplication.split_agent_name = selectedAgent.name;
             $scope.editApplication.splitAgentObject = selectedAgent;
        }
    });

     $scope.dpOpened2 = false;

    $scope.today = function() {
        var todayDate = new Date();
        $scope.minDate = todayDate;
        // $scope.editApplication.submitted_date = todayDate.getFullYear() + '-' +
        //     ('0' + (todayDate.getMonth() + 1)).slice(-2) + '-' +
        //     ('0' + todayDate.getDate()).slice(-2);        
    };

    $scope.today();
 
     $scope.open = function($event) {
         $event.preventDefault();
         $event.stopPropagation();
        //  $scope.dpOpened1 = !$scope.dpOpened1;
         $scope.dpOpened2 = !$scope.dpOpened2;
     };
  
     $scope.dateOptions = {
         formatYear: 'yyyy',
         startingDay: 0,
         class: 'datepicker',
         showWeeks:false
     };
  
     $scope.format = 'MM/dd/yyyy';

    //  $scope.$watch('$scope.editApplication.submitted_date', function (newDate) {
    //     if(newDate){
    //         $scope.editApplication.submitted_date = formatDate($scope.editApplication.submitted_date);
    //     }
    //  }); 
     $scope.$watch('$scope.editApplication.effective_date', function (newDate) {
        if(newDate){
            $scope.editApplication.effective_date = moment($scope.editApplication.effective_date).format("MM/dd/yyyy");
        }
    });
 
    $scope.clear = function () {
        $scope.editApplication.submitted_date = null;
        $scope.editApplication.effective_date = null;
    };
 
    // Disable weekend selection
    $scope.disabled = function(date, mode) {
        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };
 
    $scope.toggleMin = function() {
        $scope.minDate = $scope.minDate ? null : new Date();
    };
    $scope.toggleMin();

     $scope.openDatePickerEffective = function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedTo = true;
    };

    // $scope.checkKey = function(event) {
    //     var keyCode = event.which || event.keyCode;
    //     if ((keyCode < 48 || keyCode > 57) && 
    //         ![8, 37, 38, 39, 40, 46, 9].includes(keyCode)) {
    //         event.preventDefault();
    //     }
    // };

    $scope.checkKey = function(event) {
 
        var keyCode = event.which || event.keyCode;
        var inputValue = event.target.value || '';
        var num = '';
        var decNum = '';
        inputValue = inputValue.replace(/[^0-9.]/g, '');
        if (inputValue.includes('.')) {
            num = inputValue.split('.')[0];
            decNum = inputValue.split('.')[1];
            if (decNum.length > 1) {
                event.preventDefault(); 
                decNum = decNum.substring(0, 2);
            }
        } else {
            num = inputValue; 
        }
        inputValue = num + '.' + decNum;

        if ([8, 37, 38, 39, 40, 46, 9].includes(keyCode)) {
            return;
        }
        if (keyCode === 190) {
            if (inputValue.indexOf('.') !== -1) {
                event.preventDefault(); 
            }
            return;
        }
        if (keyCode < 48 || keyCode > 57) {
            event.preventDefault(); 
        }
        if (inputValue.includes('.')) {
            var decimalPart = inputValue.split('.')[1];
            if (decimalPart.length >= 2) {
                event.preventDefault(); 
            }
        }
    };
 
     $scope.dateOptionsDatePicker = {
         formatYear: 'yy',
         startingDay: 0,
         class: 'datepicker',
         minDate: moment(),
         showWeeks:false
     };
     //calendar ends 

     $scope.convertToYYYYMMDD = function(dateStr) {
        var date;
    
        // Check if the input is in MM/dd/yyyy format
        if (/\d{2}\/\d{2}\/\d{4}/.test(dateStr)) {
            var parts = dateStr.split('/');
            var month = parseInt(parts[0], 10) - 1; // Month is 0-indexed
            var day = parseInt(parts[1], 10);
            var year = parseInt(parts[2], 10);
            date = new Date(year, month, day);
        } 
        // Otherwise, assume it's in the Date string format
        else {
            date = new Date(dateStr);
        }
    
        // Validate date
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date');
        }
    
        var formattedYear = date.getFullYear();
        var formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
        var formattedDay = String(date.getDate()).padStart(2, '0');
    
        return formattedYear + '-' + formattedMonth + '-' + formattedDay + " 00:00:00";
    };
    

     $scope.updateApplicationForm = function(){ 
        if(!$scope.editApplication.carrierObject){
            toaster.pop('error', 'Company', 'Company field Required', 2000);
        }else if (!$scope.editApplication.submitted_date) {
            toaster.pop('error', 'Date', 'Submitted Date field is required', 2000);
            return; 
        }else if (!$scope.editApplication.effective_date) {
            toaster.pop('error', 'Date', 'Effective Date field is required', 2000);
            return; 
        }
        else if(!$scope.editApplication.productObject){
            toaster.pop('error', 'Product', 'Product field Required', 2000);
        }
        else if(!$scope.editApplication.policy_number){
            toaster.pop('error', 'Policy', 'Policy field Required', 2000);
        } else if ($scope.editApplication.split_with_agent === undefined || $scope.editApplication.split_with_agent === null) {
            toaster.pop('error', 'Split Agent', 'Split Agent field Required', 2000);
        }else if ($scope.editApplication.split_with_agent === 'yes' && !$scope.editApplication.splitAgentObject) {
            toaster.pop('error', 'Agent', 'Agent Name field Required when Split Agent is Yes', 2000);
        } 
        else if(!$scope.editApplication.insurance_type){
            toaster.pop('error', 'Insured Types', 'Insured Types field Required', 2000);
        }else if(!$scope.editApplication.annual_payment || !$scope.editApplication.monthly_payment){
            toaster.pop('error', 'Payment', 'Payment field Required', 2000);
        }
        // else if(!$scope.editApplication.annual_payment && !$scope.editApplication.monthly_payment){
        //     toaster.pop('error', 'Payment', 'Payment field Required', 2000);
        // }
        else if(!$scope.editApplication.status){
            toaster.pop('error', 'Status', 'Status field Required', 2000);
        }else {

        $scope.editApplication.carrier_id = $scope.editApplication.carrierObject.id;
        $scope.editApplication.carrier_name = $scope.editApplication.carrierObject.name;

        if ($scope.editApplication.split_with_agent) {
            $scope.editApplication.split_agent_id = $scope.editApplication.splitAgentObject.id;
            $scope.editApplication.split_agent_name =$scope.editApplication.splitAgentObject.name;
        }

        var formattedSubmittedDate = object.application.submitted_date;
        var formattedEffectiveDate = $scope.editApplication.effective_date ? $scope.convertToYYYYMMDD($scope.editApplication.effective_date) : '';
            if (!formattedSubmittedDate) {
                toaster.pop('error', 'Submitted Date', 'Submitted Date is invalid', 2000);
                return; 
            }
            if (!formattedEffectiveDate) {
                toaster.pop('error', 'Effective Date', 'Effective Date is invalid', 2000);
                return; 
            }

            $scope.editProductObject = JSON.parse($scope.editApplication.productObject);

        var updateObj = {
            agent_id:$scope.editApplication.agent_id,
            // agent_name:$scope.editApplication.agent_name,
            contact_id:$scope.editApplication.contact_id,
            application_id: $scope.editApplication.application_id,  
            carrier_id: $scope.editApplication.carrier_id,
            // carrier_name: $scope.editApplication.carrier_name,
            product_id: $scope.editProductObject.id,
            policy_number:$scope.editApplication.policy_number,
            submitted_date: formattedSubmittedDate,
            effective_date: formattedEffectiveDate,
            split_with_agent: $scope.editApplication.split_with_agent,
            // split_agent_name: $scope.editApplication.split_agent_name,
            split_agent_id: $scope.editApplication.split_agent_id,
            insurance_type:$scope.editApplication.insurance_type,
            annual_payment:parseFloat($scope.editApplication.annual_payment),
            monthly_payment:parseFloat($scope.editApplication.monthly_payment),
            status:$scope.editApplication.status,
        };

            var callbacks = {
                success: function (data) {
                    toaster.pop('success', 'Success', 'Updated Application Successfully', 2000);
                    // $rootScope.getContactApplicationDetails();
                    $scope.closeWithSuccess();
                },
                failure: function (data) {
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                }

            };
            UserService.createApplication(updateObj,callbacks);
        }
    };

    $scope.closeWithSuccess = function () {
        $modalInstance.close('ok');
    };  

    $scope.closeModal = function() {
        $modalInstance.close('cancel');
      };

}])
